<template>
	<div class="container selector" v-if="visible">
		<Navigation-bar>
			<template slot="title">
				<div class="selector_switch-nav" v-if="isCurrentFixed" @click="close()">
					<span>筛选</span>
					<YD-image src="icon/icon_下拉箭头_黑色_向上"></YD-image>
				</div>
			</template>
		</Navigation-bar>
		<div class="container_content">
			<!-- 动画占位 start-->
			<Title v-if="!isCurrentFixed && (isIn || isOut)" class="fixed">
				<template slot="spreadhead">
					<div class="selector_switch">
						<span>筛选</span>
						<YD-image src="icon/icon_下拉箭头_黑色_向上"></YD-image>
					</div>
				</template>
				<template slot="subtitle">项目 · 级别 · 性别 · 地区</template>
			</Title>
			<!-- 动画占位 end -->
			<Scroll
				:class="{
					'in': isIn,
					'out': isOut
				}"
				:scroll.sync="scrollTop"
				@scrollChange="scrollChange"
			>
				<Title v-if="!isFixed">
					<template slot="spreadhead">
						<div class="selector_switch" @click="close()">
							<span>筛选</span>
							<YD-image src="icon/icon_下拉箭头_黑色_向上"></YD-image>
						</div>
					</template>
					<template slot="subtitle">项目 · 级别 · 性别 · 地区</template>
				</Title>
				<div class="selector-body" :style="isFixed ? 'padding-top: 0.22rem' : ''">
					<div class="selector_list">
						<div class="selector_item">
							<div class="selector_item-title">运动项目</div>
							<div class="selector_item-body">
								<div
									v-for="(item,index) in eventsList"
									:key="index"
									:class="[
										'option',
										{'active': item.Events.Id == newForm.eventsId}
									]"
									@click="select('events', item.Events)"
								>
									{{item.Events.Name}}
								</div>
							</div>
						</div>
						<div class="selector_item">
							<div class="selector_item-title">{{type == 'referee' ? '裁判级别' : '教练级别'}}</div>
							<div class="selector_item-body">
								<div
									v-for="(item,index) in levelList"
									:key="index"
									:class="[
										'option',
										{'active': item.LevelNo == newForm.level}
									]"
									@click="select('level', item)"
								>
									{{item.LevelName}}
								</div>
							</div>
						</div>
						<div class="selector_item">
							<div class="selector_item-title">性别</div>
							<div class="selector_item-body">
								<div
									v-for="(item,index) in genderList"
									:key="index"
									:class="[
										'option',
										{'active': item.value == newForm.gender}
									]"
									@click="select('gender', item)"
								>
									{{item.label}}
								</div>
							</div>
						</div>
						<div class="selector_item">
							<div class="selector_item-title">所在地区</div>
							<div class="selector_item-body">
								<div 
									v-for="(item,index) in provinceList"
									:key="index"
									:class="[
										'option',
										{'active': item.code == newForm.provinceCode}
									]"
									@click="select('province', item)"
								>
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Scroll>
		</div>
		<div class="operation" v-if="!isIn && !isOut">
			<div class="button" @click="reset()"><span>重置</span></div>
			<div class="button" @click="confirm()"><span>查看</span></div>
		</div>
	</div>
</template>

<script>
	import utils from "@js/utils";
	import province from "../province.json";
	import {
		GetAllFlattedEventsRefereeLevelList,
		GetAllFlattedEventsCoachLevelList
	} from '@/api';
	export default {
		name: "selector",
		props: {
			type: {
				type: String,
				default: 'referee'
			},
			isFixed: {
				type: Boolean,
				default: false
			},
			form: {
				type: Object,
				default: ()=>{return {}}
			}
		},
		data(){
			let events_default = {Events: {Id: 0, Name: "不限"}};
			return {
				visible: false,
				isIn: false,
				isOut: false,
				scrollTop: 0,
				newScrollTop: 0,
				isCurrentFixed: this.isFixed,
				newForm: {...this.form},
				events_default,
				eventsList: [
					events_default
				],
				levelList: [
					{LevelNo: 0, LevelName: "不限"}
				],
				genderList: [
					{value: 0, label: "不限"},
					{value: 1, label: "男"},
					{value: 2, label: "女"}
				],
				provinceList: [
					{code: 0, name: "不限"},
					...province
				]
			}
		},
		created() {
			if(this.type == 'referee'){
				GetAllFlattedEventsRefereeLevelList({}).then(data=>{
					if(data.Code == 0){
						this.eventsList = [this.events_default, ...data.EventsLevels];
					}
				})
			}else{
				GetAllFlattedEventsCoachLevelList({}).then(data=>{
					if(data.Code == 0){
						this.eventsList = [this.events_default, ...data.EventsLevels];
					}
				})
			}
		},
		computed: {
			titleHeight(){
				return utils.getTitleHeightWithInt();
			}
		},
		watch:{
			form:{
				deep: true,
				handler(form){
					this.newForm = {...form};
				}
			},
			'newForm.eventsId':{
				deep: true,
				handler(eventsId){
					let form = this.newForm;
					let defaultObj = {LevelNo: 0, LevelName: "不限"};
					let levelList = [defaultObj];
					form.level = defaultObj.LevelNo;
					form.levelName = defaultObj.LevelName;
					if(eventsId != 0){
						let eventsObj = this.eventsList.filter(item=>item.Events.Id == eventsId)[0];
						if(eventsObj){
							levelList.push(...(eventsObj.Levels || []));
						}
					}
					this.levelList = levelList;
				}
			}
		},
		methods: {
			show(){
				if(this.visible)return;
				this.newForm = {...this.form};
				this.isCurrentFixed = this.isFixed;
				this.visible = true;
				this.isIn = true;
				setTimeout(()=>{
					this.isIn = false;
				}, 500)
			},
			close(){
				if(!this.visible)return;
				this.isOut = true;
				setTimeout(()=>{
					this.visible = false;
					this.isOut = false;
					this.$emit('close');
					this.$nextTick(function(){
						this.scrollTop = 0;
					})
				}, 500)
			},
			scrollChange(scrollTop) {
				if(!this.isFixed){
					this.isCurrentFixed = scrollTop > this.titleHeight;
				}
			},
			select(type, obj){
				let form = this.newForm;
				switch(type){
					case 'events':
						form.eventsId = obj.Id;
						form.eventsName = obj.Name;
						break;
					case 'level':
						form.level = obj.LevelNo;
						form.levelName = obj.LevelName;
						break;
					case 'gender':
						form.gender = obj.value;
						form.genderName = obj.label;
						break;
					case 'province':
						form.provinceCode = +obj.code;
						form.provinceName = obj.name;
						break;
				}
			},
			reset(){
				this.newForm = {
					eventsId: 0,
					eventsName: "不限",
					level: 0,
					levelName: "不限",
					gender: 0,
					genderName: "不限",
					provinceCode: 0,
					provinceName: "不限"
				};
			},
			confirm() {
				this.$emit('update:form', {...this.newForm});
				this.$emit('search');
				this.close();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.selector{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.7);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 11;
	}
	.selector_switch-nav{
		font-family: PingFangSC-Medium;
		font-size: 36px;
		color: #1B1C1E;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 32px;
			height: 32px;
			margin-left: 4px;
		}
	}
	.selector_switch{
		display: flex;
		align-items: center;
		img{
			width: 40px;
			height: 40px;
			margin-left: 12px;
		}
	}
	.scroll{
		width: 100%;
		background-color: #FFFFFF;
		&.in{
			transform: translateY(0);
			animation: in 0.4s linear;
		}
		&.out{
			transform: translateY(-100%);
			animation: out 0.4s linear;
		}
	}
	@keyframes in {
		0%{
			transform: translateY(-100%);
		}
		100%{
			transform: translateY(0);
		}
	}
	@keyframes out {
		0%{
			transform: translateY(0);
		}
		100%{
			transform: translateY(-100%);
		}
	}
	.fixed{
		width: 100%;
		background-color: #FFFFFF;
		position: fixed;
		left: 0;
		z-index: 2;
	}
	.selector-body,
	.selector_list,
	.selector_item{
		height: auto;
		width: 100%;
	}
	.selector-body{
		padding-bottom: calc(190px + var(--safe-area-inset-bottom));
		.selector_item{
			padding:0 40px;
			box-sizing: border-box;
			margin-bottom: 40px;
			.selector_item-title{
				height: 44px;
				font-family: PingFangSC-Regular;
				font-size: 28px;
				color: #333333;
				line-height: 44px;
				font-weight: 400;
			}
			.selector_item-body{
				width: 100%;
				.option{
					width: 156px;
					height: 74px;
					background-color: #FAFBFA;
					border-radius: 37px;
					display: inline-block;
					vertical-align: middle;
					margin-right: 15px;
					margin-top: 16px;
					&:nth-of-type(4n){
						margin-right: 0;
					}
					font-family: PingFangSC-Regular;
					font-size: 24px;
					color: #333333;
					text-align: center;
					font-weight: 400;
					line-height: 74px;
					&.active{
						background-color: #1B1C1E;
						color: #FFFFFF;
						font-weight: 500;
					}
				}
			}
		}
	}
	.operation{
		width: 100%;
		height: calc(190px + var(--safe-area-inset-bottom));
		background-image: linear-gradient(179deg, rgba(255,255,255,0.00) 0%, rgba(255,255,255,0.11) 2%, rgba(255,255,255,0.20) 4%, rgba(255,255,255,0.30) 5%, rgba(255,255,255,0.39) 6%, rgba(255,255,255,0.47) 8%, rgba(255,255,255,0.55) 9%, rgba(255,255,255,0.63) 10%, rgba(255,255,255,0.70) 12%, rgba(255,255,255,0.76) 14%, rgba(255,255,255,0.82) 16%, rgba(255,255,255,0.87) 20%, rgba(255,255,255,0.92) 23%, rgba(255,255,255,0.96) 28%, #FFFFFF 34%);
		display: flex;
		justify-content: center;
		padding-top: 40px;
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
		left: 0;
		.button{
			width: 288px;
			height: 108px;
			background: #F5F7F5;
			border-radius: 54px;
			margin-right: 40px;
			font-family: PingFangSC-Medium;
			font-size: 32px;
			color: #1B1C1E;
			text-align: center;
			font-weight: 500;
			line-height: 108px;
			&:nth-of-type(2){
				margin-right: 0;
				background-color: #1B1C1E;
				color: #FFFFFF;
			}
		}
	}
</style>